export const Base_Polygon: L.LatLngExpression[] = [
  [34.885931, -15.025257],
  [34.885931, 32.1809],
  [64.052978, 32.1809],
  [64.052978, -15.025257],
  [34.885931, -15.025257],
]

export const BASE_POLYGON_OPACITY = 0.7

export const BASE_BORDER_COLOR = '#8C2E46'

export const BASE_BORDER_WIDTH = 4

export const BASE_FILL_COLOR = '#261718'

export const BASE_OPACITY = 0.6

export const NO_PARKING_AREA_BORDER_OPACITY = 0.7

export const NO_PARKING_AREA_BORDER_COLOR = '#8C2E46'

export const NO_PARKING_AREA_BORDER_WIDTH = 2

export const NO_PARKING_AREA_FILL_COLOR = '#462525'

export const NO_PARKING_AREA_OPACITY = 0.4

export const ZOOM_LEVEL_TO_SHOW_OPERATION_AREAS = 10

export const ZOOM_LEVEL_TO_SHOW_NO_PARKING_AREAS = 14

export const ZOOM_LEVEL_MIN = 6

export const ZOOM_LEVEL_MAX = 18

export const ZOOM_LEVEL_MAX_DISABLE_CLUSTERING = 14

export const MAX_CLUSTER_RADIUS = 80
